import React from 'react'
import style from './Todo.module.css'
import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";

function Todo({task,deleteTodo,editTodo,toggleComplete}) {
  return (
    <div className={style.todo}>
        <p className={`${task.completed ? style.completed :style.incompleted}`} onClick={()=>toggleComplete(task.id)}>{task.task}</p> 
        <div>
        <FaEdit className={style.todoIcon} onClick={()=>{editTodo(task.id)}}/>
        <FaTrash className={style.todoIcon} onClick={()=>deleteTodo(task.id)}/>  
        </div>
    </div>
  )
}

export default Todo